// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3Rd8J","approved":"Status_approved__2fbTl","rejected":"Status_rejected__1kUB_","expired":"Status_expired__1Z3K_","label":"Status_label__2JPYc"};